export default "__VITE_ASSET__Bbnsxatc__"